import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    getVolunteers (familyEditionId, data) {
        return httpService.get(ApiEndpoints.get('volunteers', { familyEditionId }));
    },
    assignVolunteers (familyEditionId, data) {
        return httpService.put(ApiEndpoints.get('volunteers', { familyEditionId }), data);
    },
    acceptFamily (familyEditionId) {
        return httpService.put(ApiEndpoints.get('volunteer_accept_family', { familyEditionId }));
    },
    rejectFamily (familyEditionId, data) {
        return httpService.put(ApiEndpoints.get('volunteer_reject_family', { familyEditionId }), data);
    }
};
